import {
  FETCH_LEAVES_SUCCESS,
  FETCH_LEAVE_SUCCESS,
} from '../../constants/ActionTypes'

const initialSettings = {}

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_LEAVES_SUCCESS: {
      return { ...state, index: action.payload }
    }
    case FETCH_LEAVE_SUCCESS: {
      return { ...state, show: action.payload }
    }
    default:
      return state
  }
}
